// src/lib/fetchPostsGrid.ts
import type { WPPost } from "@/types/wpBase";

export type FetchPostsGridResult = {
  posts: WPPost[];
  total: number;
  totalPages: number;
  page: number;
  perPage: number;
};

export async function fetchPostsGrid(
  page: number,
  perPage: number,
  langCode?: string,
  opts?: { offset?: number }
): Promise<FetchPostsGridResult> {
  const api = process.env.NEXT_PUBLIC_API_URL;

  if (!api) {
    return { posts: [], total: 0, totalPages: 0, page, perPage };
  }

  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("per_page", String(perPage));
  params.set("status", "publish");
  params.set("_embed", "1");
  params.set(
    "_fields",
    "id,slug,link,title,excerpt,date,lang,status,featured_media,_links,_embedded"
  );

  if (langCode) params.set("lang", langCode);
  if (typeof opts?.offset === "number") params.set("offset", String(opts.offset));

  const url = `${api}/wp-json/wp/v2/posts?${params.toString()}`;

  try {
    const res = await fetch(url, { next: { revalidate: 300 } });
    if (!res.ok) throw new Error("WP fetch failed");

    const posts = (await res.json()) as WPPost[];
    const total = Number(res.headers.get("X-WP-Total") || 0);
    const totalPages = Number(res.headers.get("X-WP-TotalPages") || 0);

    return { posts: Array.isArray(posts) ? posts : [], total, totalPages, page, perPage };
  } catch {
    return { posts: [], total: 0, totalPages: 0, page, perPage };
  }
}
